import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { type ReactNode } from 'react';
import { dataverseScopes } from './config';
import { signIn, inIframe } from './loginHelpers';
import styles from './AuthGate.module.css';

type AuthGateProps = {
  children: ReactNode;
};

/**
 * Wraps the app in an auth check. Sign-in card if not signed in,
 * children otherwise. Uses signIn() which picks popup (iframed) or
 * redirect (top-level) per IFRAMED-AUTH-PATTERN.md.
 */
export function AuthGate({ children }: AuthGateProps) {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <>{children}</>;
  }

  const busy =
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Startup ||
    (inProgress as string) === 'login';

  const handleSignIn = () => {
    signIn(dataverseScopes).catch((err) => {
      console.error('signIn failed', err);
    });
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1>Compose</h1>
        <p>Sign in with your Getaquote Microsoft 365 account to continue.</p>
        <button
          type="button"
          className={styles.signIn}
          onClick={handleSignIn}
          disabled={busy}
        >
          {busy ? 'Signing in…' : 'Sign in with Microsoft'}
        </button>
        {inIframe && (
          <p className={styles.note}>
            (A Microsoft sign-in popup will open. If your browser blocks
            it, allow popups for this site and click Sign in again.)
          </p>
        )}
      </div>
    </div>
  );
}
